import { render, staticRenderFns } from "./LeaseSpaces.vue?vue&type=template&id=515ef75d&scoped=true"
import script from "./LeaseSpaces.vue?vue&type=script&lang=js"
export * from "./LeaseSpaces.vue?vue&type=script&lang=js"
import style0 from "./LeaseSpaces.vue?vue&type=style&index=0&id=515ef75d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ef75d",
  null
  
)

export default component.exports